<template>
  <div>
    <el-table
      size="mini"
      :data="visibleLanes"
      :default-sort="{ prop: sortedColumn, order: sortedDirection }"
      stripe
      @sort-change="sortLanes"
    >
      <el-table-column
        prop="label"
        label="Lane"
        min-width="160"
        fixed
        show-overflow-tooltip
      />

      <el-table-column
        prop="carrier"
        label="Carrier"
        width="140"
        show-overflow-tooltip
      />

      <el-table-column
        prop="cost"
        label="Cost"
        width="100"
        :formatter="formatCurrency"
        sortable="custom"
      />

      <el-table-column
        prop="consignments"
        label="Consignments"
        width="140"
        :formatter="formatNumber"
        sortable="custom"
      />

      <el-table-column
        prop="items"
        label="Items"
        width="100"
        :formatter="formatNumber"
        sortable="custom"
      />

      <el-table-column
        prop="volume"
        label="Volume"
        width="100"
        :formatter="formatNumber"
        sortable="custom"
      >
        <template slot-scope="scope">
          {{ formatNumber(undefined, undefined, scope.row.volume) }}m<sup>3</sup>
        </template>
      </el-table-column>

      <el-table-column
        prop="weight"
        label="Weight"
        width="100"
        :formatter="formatNumber"
        sortable="custom"
      >
        <template slot-scope="scope">
          {{ formatNumber(undefined, undefined, scope.row.weight) }}kg
        </template>
      </el-table-column>
    </el-table>

    <div class="clearfix" />

    <el-pagination
      class="pt-4 w-100 text-center"
      layout="prev, pager, next"
      :pager-count="5"
      :page-size="pageSize"
      :current-page.sync="currentPage"
      :total="totalLanes"
      background
      hide-on-single-page
      @current-change="setCurrentPage"
    />
  </div>
</template>

<script>
export default {
  props: {
    lanes: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      pageSize: 8,
      currentPage: 1,
      sortedColumn: 'cost',
      sortedDirection: 'descending'
    }
  },
  computed: {
    totalLanes () {
      return this.lanes.length
    },
    sortedLanes () {
      const allLanes = this.lanes
      const clonedLanes = (JSON.parse(JSON.stringify(allLanes)))
      const sortedColumn = this.sortedColumn
      const sortedDirection = this.sortedDirection

      return clonedLanes.sort((a, b) => {
        return (sortedDirection === 'ascending' ? parseFloat(a[sortedColumn]) > parseFloat(b[sortedColumn]) : parseFloat(a[sortedColumn]) < parseFloat(b[sortedColumn]))
      })
    },
    visibleLanes () {
      const currentPage = this.currentPage
      const pageSize = this.pageSize
      const sortedLanes = this.sortedLanes

      return sortedLanes.slice((currentPage - 1) * pageSize, currentPage * pageSize)
    }
  },
  methods: {
    sortLanes ({ order, prop }) {
      this.sortedColumn = prop
      this.sortedDirection = order
    },
    setCurrentPage (page) {
      this.currentPage = page
    },
    formatCurrency (row, column, cellValue) {
      return (new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      })).format(cellValue)
    },
    formatNumber (row, column, cellValue) {
      return (new Intl.NumberFormat('en-US')).format(cellValue)
    }
  }
}
</script>
